// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentCounterpartyEntityDetail {
    static getAttributeTypeMap() {
        return DigitalpaymentCounterpartyEntityDetail.attributeTypeMap;
    }
}
DigitalpaymentCounterpartyEntityDetail.discriminator = undefined;
DigitalpaymentCounterpartyEntityDetail.additionalProperties = false;
DigitalpaymentCounterpartyEntityDetail.attributeTypeMap = [
    {
        "name": "counterpartyEntityAliasId",
        "baseName": "counterpartyEntityAliasId",
        "type": "string"
    },
    {
        "name": "counterpartyEntityName",
        "baseName": "counterpartyEntityName",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentCounterpartyEntityDetail.js.map